import * as _ from 'lodash';
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { IAppointment, IKIOSKModel, IkioskMenuIds, IKioskOtherServiceMenu, IKioskMessage } from "../../../../models/kioskModel";
import { menuTypeAction, selectedAppointAction } from "../../../../store/actions";
import { Ilanguages } from '../../../../models/utilitiesModel';
import { getLabelConfigMsg } from "../../../../helpers/helpersIndex";

const MainMenus: React.FC = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation("translations");
    const language: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.language || Ilanguages.ENG);
    const menusData: IKioskOtherServiceMenu[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.welcomeMenus || []);
    const appoinementsData: IAppointment[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.appointmentsData || []);
    const activeAppoinements: any = Object.keys(_.groupBy(appoinementsData, ("branchType")));
    activeAppoinements.push(IkioskMenuIds.OTHERSERVICES, IkioskMenuIds.APPOINMENTS);
    const kioskConfigMsgs: IKioskMessage[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.kioskConfigdata?.kioskMessage || []);

    console.log("activeAppoinements", activeAppoinements);
    const getIcon = (menuCode) => {
        let icon = 'flow_card cyan';
        switch (menuCode) {
            case IkioskMenuIds.APPOINMENTS:
                icon = "icon_m42kiosk_appointments";
                break;
            case IkioskMenuIds.LAB:
                icon = "icon_m42kiosk_laboratory";
                break;
            case IkioskMenuIds.RADIOLOGY:
                icon = "icon_m42kiosk_radiology";
                break;
            case IkioskMenuIds.PHARMACY:
                icon = "icon_m42kiosk_pharmacy";
                break;
            case IkioskMenuIds.OTHERSERVICES:
                icon = "icon_m42kiosk_other_services";
                break;
            default:
                break;
        }
        return icon;
    };
    const handlemenuclick = (menuCode: string) => {
        if (menuCode === IkioskMenuIds.LAB || menuCode === IkioskMenuIds.PHARMACY || menuCode === IkioskMenuIds.RADIOLOGY || menuCode === IkioskMenuIds.APPOINMENTS) {
            dispatch(selectedAppointAction(menuCode));
        }
        else {
            dispatch(menuTypeAction(IkioskMenuIds.OTHERSERVICES));
        }
    };
    return (

        <div className='Kiosk_welcome'>
            {menusData?.length > 0 ? (

                <>
                    <h2>{(getLabelConfigMsg(kioskConfigMsgs, language, "Welcome") || t("kiosktranslation.Welcome" + language))}</h2>
                    <span>{(getLabelConfigMsg(kioskConfigMsgs, language, "selectOptions") || t("kiosktranslation.selectOptions" + language))}<br />{(getLabelConfigMsg(kioskConfigMsgs, language, "help") || t("kiosktranslation.help" + language))}</span>
                    <div className={`d-flex justify-content-center flex-wrap gap-5 mt-4 ${menusData.length > 3 ? 'left-align' : 'center-align'}`}>
                        {menusData?.map((x, i) => (
                            <div
                                key={i}
                                className={activeAppoinements.includes(x?.branchTypeCode) ? "flow_card pointer" : "flow_card disabled"}
                                onClick={() => { activeAppoinements.includes(x?.branchTypeCode) && handlemenuclick(x.branchTypeCode) }}>
                                <i className={getIcon(x?.branchTypeCode)}></i>
                                <span>{(getLabelConfigMsg(kioskConfigMsgs, language, x?.key) || t(`kiosktranslation.${x.key}${language}`))}</span>
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                <div className='d-flex flex-column align-items-center justify-content-center h-100'>
                    <h2>{(getLabelConfigMsg(kioskConfigMsgs, language, "noMenusMapping") || t("kiosktranslation.noMenusMapping" + language))}</h2>
                </div>
            )}

        </div>
    )}
export default React.memo(MainMenus);